import React from "react";
import PropTypes from "prop-types";
import {GoCometProvider as CometProvider} from "../../../player/js/CometProvider";

class Socket extends React.Component {
	getChildContext() {
		return {
			socketProvider: this.provider,
		};
	}

	constructor(props, context) {
		super(props, context);
		console.log('create socket provider');

        let server = props.uri;
        if (!server && props.servers?.length > 0) {
            server = props.servers[Math.floor(Math.random() * props.servers.length)];
        }

		this.provider = new CometProvider(server, true);
	}

	componentDidMount() {
		const {channels} = this.props;

		if (!(channels instanceof Array)) {
			return;
		}

		this.provider.join(channels);
	}
	componentWillUnmount() {
		const {channels} = this.props;

		if (!(channels instanceof Array)) {
			return;
		}

		this.provider.leave(channels);
	}

	render() {
        return this.props.children;
		// return React.Children.only(this.props.children);
	}
}

Socket.propTypes = {
	uri: PropTypes.string,
    servers: PropTypes.array,
    channels: PropTypes.array,
	// children: PropTypes.element.isRequired
};

Socket.childContextTypes = {
	socketProvider: PropTypes.object
};

export default Socket;
